import { ChoicePreview } from './choice-preview';
import { QuestionType } from './question-type';

export class QuestionPreview {
  questionUUID: string;
  titre: string;
  questionType: QuestionType;
  lesson?: string;
  choices: ChoicePreview[];

  constructor(question?: Partial<QuestionPreview>) {
    Object.assign(this, question);
  }
}
